import EditorFrame from "@/components/editors/EditorFrame";
import ImageButtonContent from "@/components/editors/template-blocks/image/ImageButtonContent";
import { ImageTypeTemplate } from "@/states/page-editor/template-parts/image";
import { defaultImgSrc } from "@/utils/convert-page-json";

interface Props {
  part: ImageTypeTemplate;
  formPath?: string;
  confirmPath?: string;
}

export default function ImageTemplate({ part, formPath, confirmPath }: Props) {
  // 背景設定
  const imgSrc: string =
    part.src !== undefined && part.src !== "" ? part.src : defaultImgSrc;
  const boxWidth = 620;

  const getAspectRatio = () => {
    if (part.aspectRatio !== undefined) {
      return part.aspectRatio;
    }
    // デフォルト画像の幅と高さ
    return [boxWidth, 550];
  };

  const imgAspect = getAspectRatio();

  return (
    <div
      className="relative p-4 w-full h-auto bg-center bg-no-repeat bg-cover md:max-w-[920px]"
      style={{
        backgroundImage: `url('${imgSrc}')`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        aspectRatio: imgAspect
          ? `${imgAspect[0]} / ${imgAspect[1]}`
          : undefined,
      }}
    >
      <div className="h-full md:mx-0">
        <EditorFrame>
          <ContentEditor
            part={part}
            formPath={formPath}
            confirmPath={confirmPath}
          />
        </EditorFrame>
      </div>
    </div>
  );
}

interface ContentEditorProps {
  part: ImageTypeTemplate;
  formPath?: string;
  confirmPath?: string;
}

function ContentEditor({ part, formPath, confirmPath }: ContentEditorProps) {
  switch (part.type) {
    case "image":
      return <></>;
    case "image.center":
      return <>中央寄せ</>;
    case "image.form":
      return <>中央寄せ＋フォーム</>;
    case "image.button":
      return (
        <ImageButtonContent
          part={part}
          formPath={formPath}
          confirmPath={confirmPath}
        />
      );
  }
}
